import React from 'react';
import g from 'glamorous';

import { linkColor } from '../utils/typography';

import {
  normalMargin,
  largeMargin,
  largeBreakpoint
} from '../utils/layout-units';

const Container = g.div({
  display: 'flex',
  flexWrap: 'wrap',
  padding: '8px 24px 24px',
  maxWidth: '488px',
  margin: normalMargin,
  // borderRadius: '4px',
  boxShadow: `0 0 0 1px ${linkColor}`,
  [`@media (min-width: ${largeBreakpoint})`]: {
    margin: largeMargin,
  },
});

const LinkGroup = g.div({
  marginTop: '24px',
  flex: '1 1 220px',
});

const BuyLink = ({url, name}) => (
  <div>
    <g.A
      display="inline-block"
      lineHeight="32px"
      target="_blank"
      href={url}>{name}</g.A>
  </div>
);

export default () => (
  <Container>
    <LinkGroup>
      <g.H5 margin="0 0 8px">Buy The Realist in the US:</g.H5>
      <BuyLink
        name="Amazon"
        url="https://www.amazon.com/Realist-Novel-Berenice-Abbott/dp/1781327297/" />
      <BuyLink
        name="Barnes & Noble"
        url="https://www.barnesandnoble.com/w/the-realist-sarah-coleman/1127485817?ean=9781781327296" />
    </LinkGroup>
    <LinkGroup>
      <g.H5 margin="0 0 8px">Buy The Realist in the UK:</g.H5>
      <BuyLink
        name="Amazon"
        url="https://www.amazon.co.uk/Realist-Novel-Berenice-Abbott/dp/1781327297/" />
      <BuyLink
        name="Waterstones"
        url="https://www.waterstones.com/book/the-realist/sarah-coleman/9781781327302" />
    </LinkGroup>

  </Container>
);



// WEBPACK FOOTER //
// ./src/components/buybook.js